import $ from "jquery";
export var CompanyFilesForm = function () {
    var processFormset = function (formset) {
        var checkbox = formset.find('.checkboxinput');
        checkbox.hide();
        var deleteField = formset.find('input[name*="DELETE"]');
        var deleteLabel = formset.find('label[for*="DELETE"]');
        deleteLabel.hide();
        var langCode = document.getElementById("language-code").value;
        var deleteButtonText = langCode === "fr" ? "Supprimer" : "Delete";
        var deleteButton = $("<button type=\"button\" class=\"btn btn-danger mb-2\">".concat(deleteButtonText, "</button>"));
        deleteButton.click(function () {
            checkbox.prop("checked", true);
            deleteField.val("on");
            formset.hide();
        });
        formset.append(deleteButton);
    };
    var initExistingFormsets = function () {
        $('#company_files_formset span[id$="_file"]').each(function () {
            var formset = $(this);
            processFormset(formset);
        });
    };
    $(document).ready(function () {
        initExistingFormsets();
        $("#add_more_company_files").click(function () {
            var form_idx = $("#id_formset_company_files-TOTAL_FORMS").val();
            var newEmptyForm = $("#empty_form_company_files")
                .html()
                .replace(/__prefix__/g, form_idx);
            var newFormset = $(newEmptyForm);
            processFormset(newFormset);
            $("#company_files_formset").append(newFormset);
            $("#id_formset_company_files-TOTAL_FORMS").val(parseInt(form_idx) + 1);
        });
    });
};
